import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "element-box mt-4" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  class: "d-flex mb-4",
  style: {"gap":"8px"}
}
const _hoisted_8 = { class: "row gx-2" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "mb-4" }

import { reactive } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required, email, minLength, helpers, numeric, decimal } from '@vuelidate/validators';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import BaseToggle from '@/components/base/BaseToggle.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Storybook',
  setup(__props) {

const formDataTargetGroup = reactive({
  targetGroup: "mentallyDisabledPeople",
});

const formData = reactive({
  name: '',
  email: '',
  password: '',
  role: '',
  access: false,
  gender: 'female',
  age: 0,
  salary: 0,
  toggle: false,
  mentallyDisabledPeople: true,
  peopleWithAddictionDisorders:false
});


const customRequired = helpers.withMessage('This field is required.', required);
const customMinLength = (length: number) =>
  helpers.withMessage(`Minimum length is ${length} characters.`, minLength(length));
const customEmail = helpers.withMessage('Please provide a valid email address.', email);

const rules = {
  name: { required: customRequired },
  email: { required: customRequired, email: customEmail },
  password: { required: customRequired, minLength: customMinLength(6) },
  role: { required: customRequired },
  age: { required: customRequired },
  salary: { required: customRequired },
  access: { required: (value: any) => value === true || 'You must accept access' },
  gender: { required: (value: any) => value === true || 'You must accept access' },
};

const v$ = useVuelidate(rules, formData);

const handleSubmit = () => {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleSubmit, ["prevent"]),
        class: "needs-validation",
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { for: "name" }, "Name", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(v$).name.$error }]),
            id: "name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event))
          }, null, 2), [
            [_vModelText, _unref(v$).name.$model]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).name.$errors, (err) => {
            return (_openBlock(), _createElementBlock("span", {
              key: err.$uid,
              class: "text-danger"
            }, _toDisplayString(err.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { for: "email" }, "Email", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(v$).email.$error }]),
            id: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).email.$model) = $event))
          }, null, 2), [
            [_vModelText, _unref(v$).email.$model]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).email.$errors, (err) => {
            return (_openBlock(), _createElementBlock("span", {
              key: err.$uid,
              class: "text-danger"
            }, _toDisplayString(err.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { for: "password" }, "Password", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(v$).password.$error }]),
            id: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).password.$model) = $event))
          }, null, 2), [
            [_vModelText, _unref(v$).password.$model]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).password.$errors, (err) => {
            return (_openBlock(), _createElementBlock("span", {
              key: err.$uid,
              class: "text-danger"
            }, _toDisplayString(err.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { for: "role" }, "Role", -1)),
          _withDirectives(_createElementVNode("select", {
            id: "role",
            class: _normalizeClass(["form-select", { 'is-invalid': _unref(v$).role.$error }]),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).role.$model) = $event))
          }, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("option", { value: "" }, "Select your role", -1),
            _createElementVNode("option", { value: "admin" }, "Admin", -1),
            _createElementVNode("option", { value: "user" }, "User", -1),
            _createElementVNode("option", { value: "guest" }, "Guest", -1)
          ]))], 2), [
            [_vModelSelect, _unref(v$).role.$model]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).role.$errors, (err) => {
            return (_openBlock(), _createElementBlock("span", {
              key: err.$uid,
              class: "text-danger"
            }, _toDisplayString(err.$message), 1))
          }), 128))
        ]),
        _createVNode(BaseNumber, {
          label: "Age",
          decimalPlaces: 2,
          min: -1000000,
          modelValue: formData.age,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.age) = $event)),
          validation: _unref(v$).age,
          messages: _unref(v$).age.$errors.map((err) => err.$message).join(', ')
        }, null, 8, ["modelValue", "validation", "messages"]),
        _createVNode(BaseNumber, {
          label: "Curreny",
          isCurrency: true,
          modelValue: formData.salary,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.salary) = $event)),
          validation: _unref(v$).salary,
          messages: _unref(v$).salary.$errors.map((err) => err.$message).join(', ')
        }, null, 8, ["modelValue", "validation", "messages"]),
        _createElementVNode("div", null, [
          _cache[18] || (_cache[18] = _createElementVNode("h4", null, "Checkboxes", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseCheckbox, {
              modelValue: formData.access,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.access) = $event)),
              validation: _unref(v$).access,
              label: "Access",
              required: true,
              labelPosition: 'right',
              classInput: 'me-2',
              classLabel: 'mb-0',
              messages: _unref(v$).access.$errors.map((err) => err.$message).join(', ')
            }, null, 8, ["modelValue", "validation", "messages"]),
            _createVNode(BaseCheckbox, {
              modelValue: formData.access,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.access) = $event)),
              validation: _unref(v$).access,
              label: "Checkbox disabled",
              disabled: true,
              required: true,
              labelPosition: 'right',
              classInput: 'me-2',
              classLabel: 'mb-0',
              messages: _unref(v$).access.$errors.map((err) => err.$message).join(', ')
            }, null, 8, ["modelValue", "validation", "messages"])
          ])
        ]),
        _cache[21] || (_cache[21] = _createElementVNode("h4", null, "Radios", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseRadio, {
            modelValue: formData.gender,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.gender) = $event)),
            validation: _unref(v$).gender,
            disabled: true,
            label: "Male",
            name: "gender",
            id: "male",
            required: true,
            messages: _unref(v$).gender.$errors.map((err) => err.$message).join(', '),
            classFormGroup: "col-auto"
          }, null, 8, ["modelValue", "validation", "messages"]),
          _createVNode(BaseRadio, {
            modelValue: formData.gender,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.gender) = $event)),
            validation: _unref(v$).gender,
            label: "Female",
            name: "gender",
            id: "female",
            required: true,
            messages: _unref(v$).gender.$errors.map((err) => err.$message).join(', '),
            classFormGroup: "col-auto"
          }, null, 8, ["modelValue", "validation", "messages"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[19] || (_cache[19] = _createElementVNode("h4", null, "Radio buttons custom", -1)),
          _createVNode(BaseRadio, {
            modelValue: formDataTargetGroup.targetGroup,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formDataTargetGroup.targetGroup) = $event)),
            labelPosition: "right",
            name: "Zielgruppe",
            classFormGroup: "mb-0 custom-radio",
            label: "Psychisch behinderte Menschen",
            id: "mentallyDisabledPeople"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseRadio, {
            modelValue: formDataTargetGroup.targetGroup,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formDataTargetGroup.targetGroup) = $event)),
            labelPosition: "right",
            name: "Zielgruppe",
            disabled: true,
            classFormGroup: "mb-0 custom-radio",
            label: "Menschen mit schwerwiegenden, andauernden Abhängigkeitserkrankungen",
            id: "peopleWithAddictionDisorders"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[20] || (_cache[20] = _createElementVNode("h4", null, "Toggles", -1)),
          _createVNode(BaseToggle, {
            modelValue: formData.toggle,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.toggle) = $event)),
            label: "Toggle label"
          }, null, 8, ["modelValue"])
        ]),
        _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"d-flex mb-3\" style=\"gap:8px;\" data-v-6e9b705a><div class=\"popover-custom btn btn-primary\" data-v-6e9b705a><div class=\"popover-content position-top\" data-v-6e9b705a> Title popover <h6 class=\"text-danger mt-2\" data-v-6e9b705a>test</h6></div> popover hover top </div><div class=\"popover-custom btn btn-primary\" data-v-6e9b705a><div class=\"popover-content position-bottom\" data-v-6e9b705a> Title popover <h6 class=\"text-danger mt-2\" data-v-6e9b705a>test</h6></div> popover hover bottom </div><div class=\"popover-custom btn btn-link\" data-v-6e9b705a><div class=\"popover-content position-left\" data-v-6e9b705a> Title popover <h6 class=\"text-danger mt-2\" data-v-6e9b705a>test</h6></div> popover hover left </div><div class=\"popover-custom btn btn-outline-primary\" data-v-6e9b705a><div class=\"popover-content position-right\" data-v-6e9b705a> Title popover <h6 class=\"text-danger mt-2\" data-v-6e9b705a>test</h6></div> popover hover right </div></div><button type=\"submit\" class=\"btn btn-primary\" data-v-6e9b705a>Submit</button>", 2))
      ], 32)
    ])
  ]))
}
}

})